import React from 'react';
import { usePriceListContent } from '../context/PriceListContext';
import ErrorView from '../view/ErrorView';

const ErrorWrapper = ({ children }) => {
    const { error } = usePriceListContent();

    if (error) {
        return <ErrorView />;
    }

    return <>{children}</>;
};

export default ErrorWrapper;